import format from 'date-fns/format';

export const getArticleDraftDateTitle = () =>
  `Draft ${format(new Date(), 'yyyy-MM-dd HH:mm:ss')}`;
